'use es6';

import PropTypes from 'prop-types';
import { Children, Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CLOSE } from '../../new-feature-onboarding/constants/OnboardingConstants';
import NewFeatureTourStep from '../../new-feature-onboarding/components/NewFeatureTourStep';
import { jsx as _jsx } from "react/jsx-runtime";
class CloseConversationTourStep extends Component {
  render() {
    return /*#__PURE__*/_jsx(NewFeatureTourStep, {
      stepKey: CLOSE,
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.new-feature-onboarding.conversationCloseButton.header"
      }),
      body: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.new-feature-onboarding.conversationCloseButton.body"
      }),
      placement: "bottom right",
      width: 400,
      children: Children.only(this.props.children)
    });
  }
}
CloseConversationTourStep.displayName = 'CloseConversationTourStep';
CloseConversationTourStep.propTypes = {
  children: PropTypes.node
};
export default CloseConversationTourStep;